import React from "react";
import { styles } from "./style";
import { Typography } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
export default function CarouselItem({ item }) {
  return (
    <div
      style={{
        ...styles.container,
        backgroundImage: `url(${item.bg})`,
      }}
    >
      <div
        style={{
          ...styles.overlay,
          backgroundColor: item.overlay,
        }}
      >
        <div style={styles.inner}>
          <div style={styles.top}>
            <p style={styles.new}>New</p>
            <Typography variant="h5" align="center" style={styles.heading}>
              {item.title}
            </Typography>
          </div>
          <p style={styles.detail}>{item.detail}</p>
        </div>
        <div style={styles.goDetail}>
          <p style={styles.link}>SEE DETAIL</p>
          <ArrowRightAltIcon style={styles.icon} />
        </div>
      </div>
    </div>
  );
}
